import { FC, useState } from "react";

import debounce from "lodash/debounce";

import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";

import CustomOutlinedInput from "components/CustomOutlinedInput";

import styles from "./styles";

const MIN_CHARACTERS = 2;

type CustomSearchProps = {
  onSearch: (value: string) => void;
  searchOnKeyUp?: boolean;
  placeholder?: string;
  defaultValue?: string;
};

const CustomSearch: FC<CustomSearchProps> = ({
  placeholder,
  onSearch,
  defaultValue = "",
  searchOnKeyUp = false,
}) => {
  const [isSearch, setSearch] = useState<boolean>(!!defaultValue);
  const [value, setValue] = useState<string>(defaultValue);
  const [error, setError] = useState<boolean>(false);

  const debounceOnSearch = debounce((value) => {
    onSearch(value);
  }, 100);

  const handleChange = (e) => {
    if (error && e.target.value.length >= MIN_CHARACTERS) {
      setError(false);
    }
    setValue(e.target.value);
  };

  const toggleSearch = () => {
    const toggled = !isSearch;
    if (toggled) {
      if (value?.length >= MIN_CHARACTERS) {
        setSearch(toggled);
        onSearch(value);
      } else {
        setError(true);
      }
    } else {
      setValue("");
      onSearch("");
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (value?.length >= MIN_CHARACTERS) {
        setSearch(true);
        onSearch(value);
      } else if (value?.length === 0) {
        setSearch(false);
        onSearch("");
      } else {
        setError(true);
      }
    }
  };

  const handleKeyUp = () => {
    if (searchOnKeyUp) {
      setSearch(true);
      debounceOnSearch(value);
    }
  };

  return (
    <CustomOutlinedInput
      label="SEARCH"
      inputProps={{
        placeholder,
        value,
        onChange: handleChange,
        onKeyPress: handleKeyPress,
        onKeyUp: handleKeyUp,
        endAdornment: (
          <IconButton onClick={toggleSearch}>
            {isSearch ? (
              <ClearIcon sx={styles.icon} />
            ) : (
              <SearchIcon sx={styles.icon} />
            )}
          </IconButton>
        ),
        sx: styles.input,
      }}
      formControlProps={{
        fullWidth: true,
        margin: "normal",
        sx: {
          marginTop: 0,
          marginBottom: 0,
        },
      }}
      error={error ? `Must be at least ${MIN_CHARACTERS} characters.` : ""}
    />
  );
};
export default CustomSearch;
